module.exports = __webpack_public_path__ + "img/med3.18757a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/med3.png
// module id = 9TzZ
// module chunks = 0